var map = {
	"./1940-Mahasabha-All-India-Image-1.png": 7173,
	"./1940-Mahasabha-All-India-Image-2.png": 5374,
	"./1940-Mahasabha-All-India-Image-3.png": 8391,
	"./1940-Mahasabha-All-India-Image-4.png": 3224
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2878;